<ng-container *hasPermission="PermissionForStudents.QUIZ_VIEW">
  <div class="container-fluid daily">
    <div class="row">
      <h5>Quiz Challenge</h5>
      <p>
        Strengthen your subject understanding by completing interactive quizzes!
      </p>

      <ng-container *ngIf="isLoading; else pageContent">
        <div class="app-spinner">
          <mat-spinner diameter="60"></mat-spinner>
        </div>
      </ng-container>
      <ng-template #pageContent>
        <ng-container *ngIf="studentQuizChallenge.length > 0; else showMessage">
          <div class="col-12">
            <div class="quiz-grid">
              <div
                class="quiz-card"
                *ngFor="let studentQuiz of studentQuizChallenge"
              >
                <div class="quiz-header">
                  <div class="quiz-icon">
                    <i class="bi bi-lightning-fill"></i>
                  </div>
                  <span
                    class="status"
                    [ngClass]="{
                      completed:
                        studentQuiz.status ===
                          StudentQuizChallengeStatus.COMPLETED ||
                        studentQuiz.status ===
                          StudentQuizChallengeStatus.SUBMITTED,
                      autoSubmitted:
                        studentQuiz.status ===
                        StudentQuizChallengeStatus.AUTO_SUBMITTED,
                      progress:
                        studentQuiz.status ===
                        StudentQuizChallengeStatus.IN_PROGRESS,
                      pending:
                        studentQuiz.status ===
                        StudentQuizChallengeStatus.PENDING,
                    }"
                  >
                    {{ studentQuiz.status }}</span
                  >
                </div>

                <h3
                  class="quiz-title truncate"
                  matTooltip="{{ studentQuiz.quiz_name }}"
                >
                  {{ studentQuiz.quiz_name }}
                </h3>

                <div class="quiz-meta">
                  <div>
                    <span>Date</span>
                    <strong>{{
                      studentQuiz.published_date | date: dateFormat
                    }}</strong>
                  </div>
                  <div>
                    <span>Questions</span>
                    <strong>{{ studentQuiz.total_questions }}</strong>
                  </div>
                  <div>
                    <span>Points</span>
                    <strong>{{ studentQuiz.total_marks }}</strong>
                  </div>
                </div>

                <ng-container *hasPermission="PermissionForStudents.QUIZ_TAKE">
                  <button
                    *ngIf="
                      studentQuiz.status === StudentQuizChallengeStatus.PENDING
                    "
                    class="action-btn btn-primary"
                    (click)="openTakeQuizPopup(studentQuiz)"
                  >
                    <i class="bi bi-arrow-right-circle-fill"></i> Start Quiz
                  </button>

                  <button
                    *ngIf="
                      studentQuiz.status ===
                      StudentQuizChallengeStatus.IN_PROGRESS
                    "
                    class="action-btn btn-warning"
                    (click)="
                      goToQuizDetailPage(
                        studentQuiz.quiz_id,
                        studentQuiz.attempt_id
                      )
                    "
                  >
                    <i class="bi bi-play-circle-fill"></i> Continue Quiz
                  </button>
                </ng-container>

                <ng-container
                  *hasPermission="PermissionForStudents.QUIZ_RESULT"
                >
                  <button
                    *ngIf="
                      studentQuiz.status ===
                        StudentQuizChallengeStatus.COMPLETED ||
                      studentQuiz.status ===
                        StudentQuizChallengeStatus.SUBMITTED ||
                      studentQuiz.status ===
                        StudentQuizChallengeStatus.AUTO_SUBMITTED
                    "
                    class="action-btn btn-success"
                    (click)="viewQuizResult(studentQuiz)"
                  >
                    <i class="bi bi-check-circle-fill"></i> View Result
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #showMessage>
          <p class="text-center">no quizzes available</p>
        </ng-template>
      </ng-template>
    </div>
  </div>
</ng-container>
